import classNames from 'classnames'

export const wrapperClassNames =
  'mr-3 md:min-w-[300px] flex-1 basis-3/4 w-auto brand2'

export const labelClassNames =
  'text-base font-semibold text-default mb-3 flex items-center font-effra mb-4'

export const inputClassNames = classNames(
  'relative mt-[2px] mr-2 w-5 h-5 flex-shrink-0',
  'appearance-none rounded-full border-2 border-solid border-gray-100 after:block after:absolute after:top-0 after:bottom-0 after:left-0 after:right-0 after:w-full after:content-[""] after:border-2 after:border-solid after:border-transparent after:rounded-full',
  'hover:after:bg-gray-100 hover:after:border-white hover:checked:after:bg-blue-75 checked:border-blue-75 checked:after:bg-blue-75 checked:after:border-white'
)

export const optionLabelClassNames =
  'text-base font-normal font-effra text-secondary tracking-[0.2px]'

export const inputLabelClassNames =
  'flex [&:not(:last-child)]:mb-3 cursor-pointer'
